/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApiSimpleCampaignFromJSON, ApiSimpleCampaignToJSON, } from './ApiSimpleCampaign';
export function ApiListCampaignsResponseFromJSON(json) {
    return ApiListCampaignsResponseFromJSONTyped(json, false);
}
export function ApiListCampaignsResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'campaigns': !exists(json, 'campaigns') ? undefined : (json['campaigns'].map(ApiSimpleCampaignFromJSON)),
    };
}
export function ApiListCampaignsResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'campaigns': value.campaigns === undefined ? undefined : (value.campaigns.map(ApiSimpleCampaignToJSON)),
    };
}
